import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Warehouse, Box, Layers, ClipboardList, Truck, Search, BarChart2, Settings } from 'lucide-react';
import './WmsSidebar.css';

const wmsSidebarItems = [
  { key: 'dashboard', label: 'Dashboard', icon: <Warehouse size={20} />, path: '/wms/dashboard' },
  { key: 'configuracion', label: 'Configuración', icon: <Settings size={20} />, path: '/wms/configuracion' },
  { key: 'productos', label: 'Productos', icon: <Box size={20} />, path: '/wms/productos' },
  { key: 'inventario', label: 'Inventario', icon: <Layers size={20} />, path: '/wms/inventario' },
  { key: 'recepcion', label: 'Recepción', icon: <ClipboardList size={20} />, path: '/wms/recepcion' },
  { key: 'almacenaje', label: 'Almacenaje', icon: <Layers size={20} />, path: '/wms/almacenaje' },
  { key: 'ordenes', label: 'Órdenes', icon: <Truck size={20} />, path: '/wms/ordenes' },
  { key: 'trazabilidad', label: 'Trazabilidad', icon: <Search size={20} />, path: '/wms/trazabilidad' },
  { key: 'reportes', label: 'Reportes', icon: <BarChart2 size={20} />, path: '/wms/reportes' },
  { key: 'ubicaciones', label: 'Ubicaciones', icon: <Layers size={20} />, path: '/wms/ubicaciones' },
  { key: 'almacenes', label: 'Almacenes', icon: <Warehouse size={20} />, path: '/wms/almacenes' },
];

const WmsSidebar = ({ activeItem, setActiveItem }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(true);

  // Detectar si es móvil
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // En móvil siempre expandido
  React.useEffect(() => {
    if (isMobile) setIsOpen(true);
  }, [isMobile]);

  const handleMouseEnter = () => {
    if (!isMobile) setIsOpen(true);
  };
  const handleMouseLeave = () => {
    if (!isMobile) setIsOpen(false);
  };

  return (
    <aside
      className={`wms-sidebar${isOpen ? '' : ' wms-sidebar-collapsed'}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ width: isOpen ? '256px' : '64px', minWidth: isOpen ? '256px' : '64px', minHeight: '100vh' }}
    >
      <nav>
        <ul>
          {wmsSidebarItems.map(item => (
            <li key={item.key} className={activeItem === item.key ? 'active' : ''} onClick={() => { setActiveItem(item.key); navigate(item.path); }}>
              <span className="wms-sidebar-icon">{item.icon}</span>
              {isOpen && <span>{item.label}</span>}
            </li>
          ))}
        </ul>
      </nav>
      <button
        className="wms-sidebar-logout"
        onClick={() => {
          localStorage.clear();
          navigate('/login');
        }}
        style={{
          width: '90%',
          margin: '1rem auto',
          padding: '0.75rem',
          background: '#e53935',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          fontWeight: 'bold',
          cursor: 'pointer',
          display: 'block',
        }}
      >
        Cerrar sesión
      </button>
    </aside>
  );
};

export default WmsSidebar;
